import type { IconConfig } from '@dev-fast/types';

import { environment } from '../environments/environment';

const isFastCs2Surface = environment.APP_SURFACE?.id === 'fastcs2';

const textDomainIconPath = isFastCs2Surface
  ? 'assets/img/mat-icons/logos/domain/fastcs2-domain.svg'
  : environment.CASES_ONLY_MODE
    ? 'assets/img/mat-icons/logos/domain/cases-only-domain.svg'
    : 'assets/img/mat-icons/logos/domain/csgofast.svg';

const imgDomainIconPath = environment.CASES_ONLY_MODE
  ? 'assets/img/mat-icons/logos/mirror/cases-only-icon.svg'
  : 'assets/img/mat-icons/logos/mirror/csgo.svg';

// иконки чтобы в приложении по шаблонам не заниматься заменой а в момент регистрации модулем прост их перезаменить
export const customIcons: IconConfig[] = [
  {
    name: 'text-domain',
    path: textDomainIconPath,
  },
  {
    name: 'img-domain',
    path: imgDomainIconPath,
  },
  {
    name: 'coin-primary',
    path: 'assets/img/coins/fastcoin.svg',
  },
  {
    name: 'coin-secondary',
    path: 'assets/img/coins/fastcoin.svg',
  },
  {
    name: 'free-coin',
    path: 'assets/img/coins/freecoin.svg',
  },
  {
    name: 'twin-knives',
    path: 'assets/img/knives/knives.svg',
  },
  {
    name: 'debug-menu',
    path: 'assets/img/mat-icons/debug-menu/debug-menu.svg',
  },
  {
    name: 'upgrader-rules-1',
    path: 'assets/img/mat-icons/upgrader/fast/upgrader-rules-1.svg',
  },
  {
    name: 'upgrader-rules-2',
    path: 'assets/img/mat-icons/upgrader/fast/upgrader-rules-2.svg',
  },
  {
    name: 'upgrader-rules-3',
    path: 'assets/img/mat-icons/upgrader/fast/upgrader-rules-3.svg',
  },
  {
    name: 'cases',
    path: 'assets/img/mat-icons/icons-lib/common/agentKeys/cases-fast.svg',
  },
  {
    name: 'event-progress',
    path: 'assets/img/mat-icons/icons-lib/common/agentKeys/event-progress.svg',
  },
  {
    name: 'customers-filled',
    path: 'assets/img/mat-icons/landing/customers-filled.svg',
  },
];
